import React, { Component } from 'react';
import moment from 'moment';
import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import { isSubmitting, submit } from 'redux-form';

import FlatButton from 'material-ui/FlatButton';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { MuiThemeProvider } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core/styles';
import TextField from 'material-ui/TextField';
import Drawer from '@material-ui/core/Drawer';

import { drawerStyle } from 'helpers/tableHelpers';
import { AccentColor } from 'helpers/AccentColorHelper';
import { isFilterInStrings } from 'helpers/StringHelper.js';
import { colors } from 'helpers/ColorHelper';

import {
  getTicket,
  getAllMaintenanceTickets,
  deleteTicket,
} from 'actions/maintenanceTicketActions';
import { getProperties, getUnits } from 'actions/landlordPropertiesActions';
import * as maintenanceActions from 'actions/maintenanceActions';
import { getGroupedVendors } from 'actions/vendorsActions';
import AddAndViewMaintenanceTickets from './components/AddAndViewMaintenanceTickets';
import MaintenanceAssetsMobile from './components/assets/MaintenanceAssetsMobile';
import MaintenanceAssetsTable from './components/assets/MaintenanceAssetsTable';
import AssetDetailsOverview from './components/assets/MaintenanceAssetOverview';
import HeaderWithPeriod from 'components/shared/HeaderWithPeriod';
import AssetDashboard from './components/assets/AssetDashboard';
import MenuHeader from 'components/shared/MenuHeader';
import AddAssetForm from './components/assets/AddAssetForm';
import PropertyMultiSelect from 'components/shared/PropertyMultiSelect';
import TableToggle from 'components/shared/TableToggle';
import SlideDownAnimation from 'components/shared/SlideDownAnimation';
import { getCompanyPreferences } from 'actions/companyDetailsActions';

export default withMobileDialog()(
  connect(
    (store) => ({
      ticketDetails: store.maintenanceTicket.ticketDetails,
      maintenanceAssets: store.maintenanceReducer.maintenanceAssets,
      maintenanceAsset: store.maintenanceReducer.maintenanceAsset,
      properties: store.landlordProperties.properties,
      submitting: isSubmitting('add_asset_form')(store),
      submittingMaintenance: isSubmitting('add_asset_form')(store),
      companyPreferences: store.companyDetails.companyPreferences,
    }),
    {
      ...maintenanceActions,
      getTicket,
      getAllMaintenanceTickets,
      deleteTicket,
      getGroupedVendors,
      getProperties,
      getUnits,
      submit,
      getCompanyPreferences,
    }
  )(
    class LandlordAssets extends Component {
      constructor(props) {
        super(props);
        this.state = {
          filter: 'All',
          typeFilter: '',
          filteredValue: '',
          filterClosed: true,
          selectedProperties: [],
          selectedPropertiesMultiSelect: [],
          maintenanceAssetDetails: {},
          tableData: [],
          showFilters: true,
          showFilterVerbiage: 'Hide Dashboard',
          containerSize: 'calc(100% - 320px)',
          drawerIsOpen: false,
          showDrawer: false,
          showInactiveAssets: false,
          maintenanceTicketDrawerIsOpen: false,
          showMaintenanceDrawer: false,
        };
      }

      componentDidMount = () => {
        this.getAllMaintenanceAssets();
        this.props.getProperties({ for_multiselect_single_unit: true });
        this.props.getCompanyPreferences();
      };

      componentDidUpdate(prevProps, prevState) {
        if (this.state.filteredValue !== prevState.filteredValue) {
          this.filterByProperty();
        }
      }

      getAllMaintenanceAssets = () => {
        let options = {};
        if (this.state.showInactiveAssets) {
          options = { show_inactive: true };
        }

        return this.props.getAssets(options).then(() => {
          this.setState({ tableData: this.props.maintenanceAssets });
        });
      };

      toggleDrawer = (maintenanceAssetID) => {
        if (!this.state.showDrawer && maintenanceAssetID) {
          this.props.getAssetDetails(maintenanceAssetID).then(() => {
            this.setState({
              showDrawer: true,
            });
          });
          return;
        }

        this.setState({
          showDrawer: false,
        });
      };

      getTypeFilterType = (e) => {
        this.setState({
          typeFilter: e.target.value,
          filteredValue: e.target.value,
          tableData: this.filterTicketWithString(e.target.value),
        });
      };

      onPropertySelect = (properties) => {
        this.setState({
          selectedProperties: properties.map((property) => property.label),
          selectedPropertiesMultiSelect: properties,
          filteredValue: '',
          typeFilter: '',
          tableData: this.props.maintenanceAssets,
        });

        this.filterByProperty(
          properties.map((property) => property.label),
          this.props.maintenanceAssets
        );
      };

      filterByProperty = (propertyList, maintenanceAssets) => {
        let filterBy = propertyList || this.state.selectedProperties;
        let filteredTickets = maintenanceAssets || this.state.tableData;

        if (filterBy.length === 0) {
          this.setState({ tableData: filteredTickets });
        } else {
          this.setState({
            tableData: filteredTickets.filter((ticket) => filterBy.includes(ticket.property_name)),
          });
        }
      };

      addAsset = (formData) => {
        return this.props.createOrUpdateMaintenanceAsset(formData).then(() => {
          this.toggleAssetDetails();
          this.getAllMaintenanceAssets();
        });
      };

      updateAsset = (formData, assetID = null) => {
        if (assetID) {
          return this.props.createOrUpdateMaintenanceAsset(formData, assetID).then(() => {
            this.getAllMaintenanceAssets();
          });
        }

        return this.props
          .createOrUpdateMaintenanceAsset(formData, this.props.maintenanceAsset.id)
          .then(() => {
            this.getAllMaintenanceAssets();
            this.props.getAssetDetails(this.props.maintenanceAsset.id);
          });
      };

      filterTicketWithString = (filterBy) => {
        return this.props.maintenanceAssets.filter((item) =>
          isFilterInStrings(
            [item.status, item.location, item.name, item.make, item.model, item.category],
            filterBy
          )
        );
      };

      filterTable = (filterAction) => {
        if (filterAction === this.state.filteredValue) {
          this.setState({
            filteredValue: '',
            typeFilter: '',
            tableData: this.props.maintenanceAssets,
          });
        } else if (filterAction === '48hours') {
          const maintenanceOlderThan48Hours = this.props.maintenanceAssets.filter((ticket) =>
            moment().subtract(48, 'hours').isAfter(moment(ticket.request_date))
          );
          this.setState({
            tableData: maintenanceOlderThan48Hours,
            filteredValue: filterAction,
            typeFilter: '',
          });
        } else if (filterAction === 'pastScheduled') {
          const ticketsPastSchedule = this.props.maintenanceAssets.filter((ticket) =>
            moment().isAfter(moment(ticket.scheduled_at))
          );
          this.setState({
            tableData: ticketsPastSchedule,
            filteredValue: filterAction,
            typeFilter: '',
          });
        } else {
          this.setState({
            typeFilter: filterAction,
            filteredValue: filterAction,
            tableData: this.filterTicketWithString(filterAction),
          });
        }
      };

      pieChartValues = () => {
        const statuses = [
          'Healthy',
          'Service Due',
          'WO Outstanding',
          'Broken',
          'Replace',
          'Offline',
          'Inactive',
        ];
        const maintenanceAssets = this.state.tableData;

        return statuses.map((status) => {
          return {
            name: status,
            value: maintenanceAssets.filter(
              (ticket) => ticket.status.toLowerCase() === status.toLowerCase()
            ).length,
          };
        });
      };

      toggleShowFilter = () => {
        this.setState({
          showFilterVerbiage: this.state.showFilters ? 'Show Dashboard' : 'Hide Dashboard',
          showFilters: !this.state.showFilters,
          containerSize: this.state.showFilters ? 'calc(100% - 140px)' : 'calc(100% - 320px)',
        });
      };

      toggleAssetDetails = () => {
        this.setState({ drawerIsOpen: !this.state.drawerIsOpen });
      };

      deleteAsset = () => {
        return this.props.deleteAsset(this.props.maintenanceAsset.id).then(() => {
          this.toggleDrawer();
          this.getAllMaintenanceAssets();
        });
      };

      toggleInactiveAssets = () => {
        this.setState(
          { showInactiveAssets: !this.state.showInactiveAssets },
          this.getAllMaintenanceAssets
        );
      };

      addTicket = (formData) => {
        return this.props.createOrUpdateMaintenanceTicket(formData).then(() => {
          this.toggleAddTicket();
          this.props.getAssetDetails(this.props.maintenanceAsset.id);
        });
      };

      toggleAddTicket = () => {
        this.setState({ maintenanceTicketDrawerIsOpen: !this.state.maintenanceTicketDrawerIsOpen });
      };

      toggleMaintenanceDrawer = async (maintenanceTicketID) => {
        if (!this.state.showMaintenanceDrawer && maintenanceTicketID) {
          await this.props.getTicket(maintenanceTicketID);
          let assetParams = {
            property_id: this.props.ticketDetails.property_id,
            for_multiselect: true,
          };

          const unitId = this.props.ticketDetails.unit_id;

          if (unitId) {
            assetParams = { ...assetParams, unit_id: unitId };
          }
          await this.props.getAssets(assetParams);
          await this.props.getUnits(this.props.ticketDetails.property_id, {
            for_multiselect: true,
          });
          this.props.getMaintenanceCategories(this.props.ticketDetails.property_id);
          this.props.getMaintenanceLocations(this.props.ticketDetails.property_id);
          this.setState({
            showMaintenanceDrawer: true,
          });
          this.props.getGroupedVendors();
          return;
        }

        this.setState({
          showMaintenanceDrawer: false,
        });
      };

      updateTicket = (formData, ticketID) => {
        if (ticketID) {
          return this.props.createOrUpdateMaintenanceTicket(formData, ticketID).then(() => {
            this.props.getAssetDetails(this.props.maintenanceAsset.id);
          });
        }

        return this.props
          .createOrUpdateMaintenanceTicket(formData, this.props.ticketDetails.id)
          .then(() => {
            this.props.getAssetDetails(this.props.maintenanceAsset.id);
            this.props.getTicket(this.props.ticketDetails.id);
          });
      };

      deleteTicket = () => {
        return this.props.deleteTicket(this.props.ticketDetails.id).then(() => {
          this.toggleDrawer();
          this.props.getAssetDetails(this.props.maintenanceAsset.id);
        });
      };

      createOrUpdateTask = (task, taskID) => {
        this.props.createOrUpdateMaintenanceTask(task, taskID, this.props.ticketDetails.id);
      };

      deleteTask = (taskId) => {
        this.props.deleteTask(taskId, this.props.ticketDetails.id);
      };

      render() {
        const data = this.state.tableData || [];

        return (
          <div className="body" role="main">
            <div className="centers">
              <HeaderWithPeriod
                headerText="Assets"
                actionButtonLabel="Add Asset"
                toggleDialog={this.toggleAssetDetails}
              />

              <AddAndViewMaintenanceTickets
                addTicket={this.addTicket}
                fullScreen={this.props.fullScreen}
                drawerIsOpen={this.state.maintenanceTicketDrawerIsOpen}
                toggleAddTicket={this.toggleAddTicket}
                showDrawer={this.state.showMaintenanceDrawer}
                toggleDrawer={this.toggleMaintenanceDrawer}
                updateTicket={this.updateTicket}
                deleteAction={this.deleteTicket}
                createOrUpdateTask={this.createOrUpdateTask}
                deleteTask={this.deleteTask}
                maintenanceTicket={this.props.ticketDetails}
                submittingMaintenance={this.props.submittingMaintenance}
                submitMaintenanceTicket={() => this.props.submit('add_ticket_form')}
                companyPreferences={this.props.companyPreferences}
              />

              {this.renderAddAssetFormDialog()}

              {this.renderAssetOverview()}

              <div className="row">
                <SlideDownAnimation>
                  {this.state.showFilters && (
                    <AssetDashboard
                      onClickAction={this.filterTable}
                      filterValue={this.state.filteredValue}
                      pieChartValues={this.pieChartValues()}
                      data={data}
                    />
                  )}
                </SlideDownAnimation>
              </div>
              {this.renderTableView()}
              {this.renderMobileView()}
            </div>
          </div>
        );
      }

      renderAddAssetFormDialog = () => {
        return (
          <Dialog
            disableBackdropClick
            fullScreen={this.props.fullScreen}
            open={this.state.drawerIsOpen}
            onClose={this.toggleAssetDetails}
            aria-labelledby="add-new-asset"
            classes={{
              paper: 'form-dialog',
            }}
          >
            <DialogTitle id="add-new-asset">
              <h3 style={{ textAlign: 'center', margin: 0 }}>Add New Asset</h3>
            </DialogTitle>
            <DialogContent style={{ padding: 0 }}>
              <AddAssetForm
                onSubmit={this.addAsset}
                formName="add_asset_form"
                initialValues={{ energy_efficient: false }}
              />
            </DialogContent>
            <DialogActions style={{ display: 'block' }}>
              <FlatButton
                onClick={this.toggleAssetDetails}
                id="close-button"
                style={{ color: AccentColor() }}
              >
                CANCEL
              </FlatButton>
              <FlatButton
                variant="raised"
                onClick={() => this.props.submit('add_asset_form')}
                disabled={this.props.submitting}
                id="submit-button"
                style={{
                  color: 'white',
                  backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
                }}
              >
                SAVE
              </FlatButton>
            </DialogActions>
          </Dialog>
        );
      };

      renderAssetOverview = () => (
        <MuiThemeProvider theme={createMuiTheme(drawerStyle)}>
          <Drawer open={this.state.showDrawer} onClose={this.toggleDrawer} anchor="left">
            <AssetDetailsOverview
              toggleDrawer={this.toggleDrawer}
              maintenanceAsset={this.props.maintenanceAsset}
              updateAsset={this.updateAsset}
              deleteAction={this.deleteAsset}
              toggleAddTicket={this.toggleAddTicket}
              toggleMaintenanceDrawer={this.toggleMaintenanceDrawer}
              updateTicket={this.updateTicket}
            />
          </Drawer>
        </MuiThemeProvider>
      );

      renderMobileView = () => {
        return (
          <MediaQuery query="(max-device-width: 750px)">
            <div className="row" style={{ height: this.state.containerSize }}>
              <div
                className="row"
                style={{
                  margin: '0px -15px 0',
                  padding: '20px 15px 0px',
                  borderBottom: `1px solid ${colors.LIGHT_GRAY}`,
                }}
              >
                {this.renderTextFieldSearch()}
                {this.renderExpansionToggle('unset')}
              </div>
              <MaintenanceAssetsMobile
                data={this.state.tableData}
                goToTicket={this.toggleDrawer}
                getMaintenanceAssets={this.getAllMaintenanceAssets}
                updateAsset={this.updateAsset}
              />
            </div>
          </MediaQuery>
        );
      };

      renderTableView = () => {
        return (
          <MediaQuery query="(min-device-width: 750px)">
            <div className="row" style={{ height: this.state.containerSize }}>
              {this.renderTextFieldSearch()}
              {this.renderExpansionToggle('right')}
              <div className="row" style={{ marginBottom: '15px' }}>
                <div style={{ width: '250px', float: 'right' }}>
                  <PropertyMultiSelect
                    onPropertySelect={this.onPropertySelect}
                    properties={this.props.properties}
                    selectedProperties={this.state.selectedPropertiesMultiSelect}
                  />
                </div>
                <div style={{ width: '140px' }}>
                  <TableToggle
                    toggleAction={this.toggleInactiveAssets}
                    toggleVerbiage="Show Inactive"
                  />
                </div>
              </div>

              <MaintenanceAssetsTable
                data={this.state.tableData}
                goToTicket={this.toggleDrawer}
                getMaintenanceAssets={this.getAllMaintenanceAssets}
                updateAsset={this.updateAsset}
              />
            </div>
            <div style={{ height: '10px' }} />
          </MediaQuery>
        );
      };

      renderTextFieldSearch = () => {
        return (
          <TextField
            hintText="Filter by Unit, Property, Ticket #, Subject..."
            style={{ fontSize: '13px' }}
            value={this.state.typeFilter}
            onChange={this.getTypeFilterType}
          />
        );
      };

      renderExpansionToggle = (float) => {
        return (
          <span style={{ marginTop: '5px', float: float }} onClick={this.toggleShowFilter}>
            <MenuHeader
              menuTitle={this.state.showFilterVerbiage}
              isOpen={this.state.showFilters}
              paddingMargin="0 0 5px"
              padding="5px 0"
              backgroundColor="unset"
              style={{ textAlign: 'center', padding: 0 }}
              float="initial"
              color={colors.BLUE}
            />
          </span>
        );
      };
    }
  )
);
